import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startSending, endSending } from "../progress/pogressSlice";    
import { serverErrors } from "../";
import * as api from '../../api';

const initialState = {
    dataChart: [],
    events: [],
    hours: 0,
    status: 'idle',
    total: 0,
    user: '',
    years: []
}

const dir = `records/search`;

export const search = createAsyncThunk('/search/events', async ({ id, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        const { data } = await api.getData(`${dir}/${id}`);
        thunkAPI.dispatch(endSending());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue()
    }
})

export const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        clearResult: (state) => initialState
    },
    extraReducers(builder){
        builder
            .addCase(search.fulfilled, (state, action) => {
                const { events, user, dataChart, total, hours, years } = action.payload;
                state.dataChart = dataChart
                state.hours = hours
                state.events = events
                state.status = 'succeeded'
                state.total = total
                state.user = user
                state.years = years
            })
    }
});

export const { clearResult } = searchSlice.actions;

export default searchSlice.reducer;